import { Button, Select } from "antd";
import { Box } from "../../../../components";
import { useEffect, useState } from "react";
import { useDocumentTags } from "../../../setting/document/document-tags/hooks/useDocumentTags";
import { useSearchParams } from "../../../../hook/use-search-params";
import { useDocumentsInfo } from "../../../statistics/hooks/use-documents-info";
import DataGrid, { Column, ColumnFixing, FilterRow, HeaderFilter, Paging, Scrolling } from "devextreme-react/data-grid";
import { DocumentDataGridItem } from "./document-datagrid-item";
import { documentStatus } from "../../../../constants";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { openUrl } from "../../../../helper/util";

export const DocumentTagsList = () => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const { dataOptions } = useDocumentTags();
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { documentDataHasTags } = useDocumentsInfo();
  const statusQuery = searchParams.get("status");
  const tags = searchParams.get("tags");
  const history = useHistory();

  const handleFilterClick = () => {
    if (selectedTags.length === 0) {
      searchParams.delete("tags");
      replaceSearchParams(searchParams);
      return;
    }
    searchParams.set("tags", selectedTags.toString());
    replaceSearchParams(searchParams);
  };

  const openDocumentUrl = (item: any) => {
    if (item?.docTypeId !== "2") {
      goToDetail(item);
      return;
    }

    openUrl(item?.url);
  };

  const goToDetail = (item: any, action: string = "", mode: string = "", templateId: any = null) => {
    let itemId = item?.listItemId;
    if (statusQuery === documentStatus.publish.value) itemId = item?.docWorkingId;

    if (!itemId) {
      itemId = 0;
    }
    let filters = [];

    if (action !== null && action !== "") filters.push(`action=${action}`);

    if (statusQuery === documentStatus.publish.value) {
      filters.push(`status=${statusQuery}`);
    }

    if (mode !== "") {
      filters.push(`mode=${mode}`);
    }

    if (item?.id) {
      filters.push(`fileId=${item.fileId}`);
    }

    if (item?.docTypeId === "2") {
      filters.push(`action=info`);
    }

    if (statusQuery === documentStatus.needProcess.value) {
      filters.push(`action=link`);
    }

    let filterQuery = "";
    if (filters.length > 0) {
      filterQuery = `?${filters.join("&")}`;
    }
    history.push(Routes.documentDetail.path.replace(":id", `${itemId}${filterQuery}`));
  };

  useEffect(() => {
    if (tags) {
      const tagArr = tags.split(",");
      setSelectedTags(tagArr);
    }
  }, [tags]);

  return (
    <div className={"Content__grid-hide"}>
      <Box title={"Tài liệu theo chủ đề"}>
        <div className="d-flex justify-content-between pb-2">
          <div className="d-flex column">
            <Select
              options={dataOptions}
              placeholder="Vui lòng chọn chủ đề"
              mode="multiple"
              size="large"
              optionFilterProp="label"
              value={selectedTags}
              style={{ width: "400px" }}
              onChange={(value) => setSelectedTags(value)}
              allowClear
            />
            <Button
              style={{ paddingTop: "-20px", paddingBottom: "-10px", marginLeft: "10px" }}
              onClick={() => handleFilterClick()}
              type="primary"
              size="large"
            >
              Lọc dữ liệu
            </Button>
          </div>
          <p className="font-weight-bold">
            Tổng cộng:{" "}
            <span className="text-primary" style={{ fontSize: "22px" }}>
              {documentDataHasTags?.length}
            </span>{" "}
            tài liệu
          </p>
        </div>
        <DataGrid
          id="grid__title-container"
          dataSource={documentDataHasTags}
          noDataText="Không tìm thấy tài liệu"
          showBorders={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          dataRowRender={(datRow) => (
            <DocumentDataGridItem
              document={datRow.data}
              isShowAction={false}
              isShowCheckColumn={false}
              openDocumentUrl={openDocumentUrl}
              goToDetail={goToDetail}
              wordWrapEnabled={true}
            />
          )}
        >
          <Scrolling mode="standard" />
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} applyFilter={true} />
          <HeaderFilter visible={true} />
          <Paging defaultPageSize={20} />

          <Column
            fixed={true}
            fixedPosition="left"
            dataField="Title"
            caption="Tên tài liệu"
            minWidth={200}
            allowFixing={true}
            allowHeaderFiltering={false}
          />
          <Column dataField="docCode" caption="Mã tài liệu" allowHeaderFiltering={false} alignment="left" />
          <Column dataField="docType" caption="Loại tài liệu" />
          <Column dataField="docStatus" caption="Tình trạng" />
          <Column
            dataField="createdDateTime"
            dataType="date"
            selectedFilterOperation="between"
            caption="Ngày hiệu lực"
          />
          <Column
            dataField="docPublishViewVersion"
            caption="Lần ban hành"
            dataType="number"
            allowHeaderFiltering={false}
            width={80}
          />
          <Column
            dataField="docEditionVersion"
            caption="Lần sửa đổi"
            dataType="number"
            allowHeaderFiltering={false}
            width={80}
          />
          <Column
            dataField="createdDateTime"
            caption="Thời gian khởi tạo"
            dataType="date"
            selectedFilterOperation="between"
            allowHeaderFiltering={false}
          />
          <Column dataField="createdUser.displayName" caption="Người khởi tạo" dataType="string" />
          <Column
            dataField="lastModifiedDateTime"
            caption="Thời gian cập nhật"
            dataType="date"
            selectedFilterOperation="between"
            allowHeaderFiltering={false}
            sortOrder="desc"
          />
          <Column dataField="modifiedUser.displayName" caption="Người cập nhật" dataType="string" />
          <Column dataField="tags" caption="Chủ đề" allowHeaderFiltering={false}>
            <HeaderFilter />
          </Column>
        </DataGrid>
      </Box>
    </div>
  );
};
